import { render, staticRenderFns } from "./user-data-registrations-card.vue?vue&type=template&id=bc9a4ef8&scoped=true&"
import script from "./user-data-registrations-card.vue?vue&type=script&lang=ts&"
export * from "./user-data-registrations-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9a4ef8",
  null
  
)

export default component.exports